module.exports = __webpack_public_path__ + "static/media/logo.cb36d28d.png";